import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { BehaviorSubject, filter } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class NavbarService {
  private sidebarOpen$ = new BehaviorSubject<boolean>(false);

  constructor(private router: Router) {
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        this.sidebarOpen$.next(false)
      });
  }

  toggleMobileSidebarOpen() {
    this.sidebarOpen$.next(!this.sidebarOpen$.value);
  }

  closeSidebar() {
    this.sidebarOpen$.next(false);
  }

  getSidebarState() {
    return this.sidebarOpen$.asObservable();
  }
}
